/**
 * @file src/pages/invoice-processing-queue/useCancelUpload.js
 * @description React Query mutation to cancel (delete) an invoice upload
 * from the processing queue. Permanently deletes the file and soft-deletes
 * the record. On success, the batch status query is invalidated so the
 * cancelled invoice disappears from the queue.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteUpload } from "api/invoice.api";

export const useCancelUpload = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (recordId) => deleteUpload(recordId, true),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["batchInfo"] });
    },
  });
};
